module.exports = __webpack_public_path__ + "img/card-32cardcasino.4f10caa.jpg";